export default __webpack_public_path__ + "static/media/shirt10.21ce4c10.jpeg";